import { getIpeWorkspaceMode } from '@/utils/api';

function resolvePackScope(packScope) {
  return packScope === 'team' || packScope === 'personal'
    ? packScope
    : getIpeWorkspaceMode();
}

/** 打开充值页 /ipe/recharge */
export function openPurchaseModal(detail = {}) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent('ipe:open-purchase-modal', { detail }));
}

export function openCreditsPurchaseModal(packScope) {
  openPurchaseModal({
    tab: 'packs',
    packGroup: 'credit',
    packScope: resolvePackScope(packScope),
  });
}

export function openShopPurchaseModal(packScope) {
  openPurchaseModal({
    tab: 'packs',
    packGroup: 'shop',
    packScope: resolvePackScope(packScope),
  });
}

export function openMembershipPurchaseModal(packScope) {
  openPurchaseModal({
    tab: 'membership',
    packScope: resolvePackScope(packScope),
  });
}
